import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  ReactNode,
} from 'react';
import { DEFAULT_INDUSTRY } from 'src/constants';
import { LocalStorageKeys } from 'src/enums';
import { Industry } from 'src/types/industry';

const IndustryContext = createContext<
  | {
      industry: Industry;
      setIndustry: React.Dispatch<React.SetStateAction<Industry>>;
    }
  | undefined
>(undefined);

interface IndustryProviderProps {
  children: ReactNode;
}

export const IndustryProvider: React.FC<IndustryProviderProps> = ({
  children,
}) => {
  const [industry, setIndustry] = useState<Industry>(() => {
    const storedIndustry = localStorage.getItem(LocalStorageKeys.INDUSTRY);
    return (storedIndustry || DEFAULT_INDUSTRY) as Industry;
  });

  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.INDUSTRY, industry);
  }, [industry]);

  return (
    <IndustryContext.Provider value={{ industry, setIndustry }}>
      {children}
    </IndustryContext.Provider>
  );
};

export const useIndustry = () => {
  const context = useContext(IndustryContext);
  if (!context) {
    throw new Error('useIndustry must be used within an IndustryProvider');
  }
  return context;
};
